import React from 'react';
import { motion } from 'framer-motion';
export function StatsBar() {
  const stats = [{
    value: '+500',
    label: 'mujeres ya recuperaron el control'
  }, {
    value: '5',
    label: 'Tomos completos'
  }, {
    value: '5',
    label: 'Bonos incluidos'
  }, {
    value: '4.9/5',
    label: 'calificación ⭐'
  }];
  return <div className="w-full bg-brand-black py-16 md:py-24 overflow-hidden border-t border-brand-green/20" data-id="element-303">
      <div className="container mx-auto px-6" data-id="element-304">
        <div className="grid grid-cols-2 gap-y-14 gap-x-6 md:gap-y-16 md:gap-x-12 max-w-2xl mx-auto" data-id="element-305">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center" data-id="element-306">
              <div className="text-5xl md:text-7xl font-heading font-bold text-white mb-2" data-id="element-307">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-brand-light font-semibold leading-tight" data-id="element-308">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}